import { formatEmployeeThaiName } from '../../../../utils/functions/employeeName';

export const fmtMoney = (v) =>
  (Number(v) || 0).toLocaleString('th-TH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function budgetLabel(row) {
  const proj = row?.project?.project_number || '';
  const budget = `${row?.budget?.prefix || ''}${
    row?.budget?.budget_number || ''
  }`;
  return [proj, budget].filter(Boolean).join(' | ') || '-';
}

// แถวที่ 1 = รหัสโครงการ/งบ (เหมือน budgetLabel เดิม), แถวที่ 2 = ชื่องบประมาณเท่านั้น (ไม่เอาชื่อโครงการ),
// remaining = งบคงเหลือ (budget.cost - budget.total_expenses, sync จาก syncBudgetExpenses ใน
// expenses.service.js ทุกครั้งที่มีการเพิ่ม/แก้/ลบ expense ผูกกับ budget นี้) — ใช้ในคอลัมน์ "งาน-รหัสงบ"
// ของตาราง null = ไม่มีข้อมูล budget (ไม่โชว์ label คงเหลือ)
export function budgetLines(row) {
  const codeLine = budgetLabel(row);
  const nameLine = row?.budget?.name || '';
  const hasBudgetTotals =
    row?.budget?.cost != null && row?.budget?.total_expenses != null;
  const remaining = hasBudgetTotals
    ? Number(row.budget.cost) - Number(row.budget.total_expenses)
    : null;
  return { codeLine, nameLine, remaining };
}

export function payeeLabel(row) {
  return (
    row?.payee?.name ||
    formatEmployeeThaiName(row?.employee) ||
    '-'
  );
}
